import Box from '@mui/material/Box';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { getFormattedTimeFromSec } from 'helpers';
import React from 'react';
import 'scss/audioindicator.scss';

const classes = {
	root: (theme) => ({
		margin: 0,

		'&.selected': {
			color: theme.palette.primary.main,

			'& .MuiTypography-root': {
				// 'font-weight': 'bold'
				color: theme.palette.primary.main,
			},
		},
	}),
	header: {
		padding: '16px 0',
		margin: '0 16px',

		'& .MuiCardHeader-title': {
			fontSize: '1.6rem',
			whiteSpace: 'nowrap',
		},
		'& .MuiCardHeader-content': {
			minWidth: 0,
		},
		'& .MuiCardHeader-action': {
			alignSelf: 'auto',
			marginTop: 0,
			marginRight: 0,
		},
	},
	audioLength: (theme) => ({
		fontSize: 14,
		padding: theme.spacing(2),
		marginRight: '-8px',
		marginTop: '-8px',
	}),
};

interface PlayListRowProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
	loading?: boolean;
	selected: boolean;
	last: boolean;
	title?: React.ReactNode;
	titleClass?: string;
	subheader?: React.ReactNode;
	length?: number;
	'data-testid'?: string;
}

/** A row of the full-screen player's list (tracks of a playlist, or chapters of an audio journal). */
export function PlayListRow({ loading, selected, last, title, titleClass, subheader, length, ...rest }: PlayListRowProps) {
	return (
		<Box className={clsx({ selected })} sx={classes.root} {...rest}>
			<CardHeader
				sx={classes.header}
				style={{ borderBottom: last ? 'none' : '1px solid grey' }}
				action={
					loading ? null : selected ? (
						<div className="audioindicator" style={{ marginRight: '-16px' }} />
					) : (
						<Box sx={classes.audioLength}>{getFormattedTimeFromSec(length as number)}</Box>
					)
				}
				title={
					loading ? (
						<Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
					) : (
						<Typography noWrap className={titleClass}>
							{title}
						</Typography>
					)
				}
				subheader={
					loading ? (
						<Skeleton animation="wave" height={10} width="40%" />
					) : (
						<Typography variant="body2" color="textSecondary">
							{subheader}
						</Typography>
					)
				}
			/>
		</Box>
	);
}
